import axiosInstance from "../utils/axios"
import { parseFilenameFromDisposition } from "../utils/download"
// import { handleApiError } from "../utils/errorHandler"

export const complaintService = {
  fetchAll: async (params = {}) => {
    const response = await axiosInstance.get('/complaint/paginate', {
      params,
    })
    return response.data
  },
  fetchAllnonCustomer: async (params = {}) => {
    const response = await axiosInstance.get('/complaint/non-customer', {
      params,
    })
    return response.data
  },
  getById: async (id) => {
    const response = await axiosInstance.get('/complaint/' + id)
    return response.data
  },
  getSummary: async (params = {}) => {
    const response = await axiosInstance.get('/complaint/summary', {
      params
    })
    return response.data
  },
  changeStatus: async (id, data) => {
    const response = await axiosInstance.post(`/complaint/${id}/change-status`, data)
    return response.data
  },
  findStatus: async (id) => {
    const response = await axiosInstance.get(`/complaint/${id}/status`)
    return response.data
  },
  addProgress: async (id, data) => {
    const response = await axiosInstance.postForm(`/complaint/${id}/add-progress`, data)
    return response.data
  },
  deleteProgress: async (id) => {
    const response = await axiosInstance.delete(`/complaint/progress/${id}`)
    return response.data
  },
  updateProgress: async (id, data) => {
    const response = await axiosInstance.post(`/complaint/${id}/update-progress`, data)
    return response.data
  },
  addFeedbackAttachment: async (id, data) => {
    const response = await axiosInstance.postForm(`/complaint/feedback-attachment/${id}`, data)
    return response.data
  },
  deleteFeedbackAttachment: async (id) => {
    const response = await axiosInstance.delete(`/complaint/feedback-attachment/${id}`)
    return response.data
  },
  update: async (data) => {
    const response = await axiosInstance.put(`/complaint/${data.id}`, data)
    return response.data
  },
  export: async (params) => {
    const response = await axiosInstance.get(`/complaint/export`, {
      params,
      responseType: 'blob'
    })

    const disposition = response.headers["content-disposition"];
    const filename = parseFilenameFromDisposition(disposition) || "complaint-export.xlsx";
    return { blob: response.data, filename };
  },
  updateFlagging: async (id, data) => {
    const response = await axiosInstance.put(`/complaint/${id}/change-flagging`, data)
    return response.data
  }
}